import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ModalCard } from 'partial/components/Modal';
import AsyncButton from 'modules/common/components/AsyncButton';

import { useDeleteBannedWord } from '../hooks';

const Delete = ({ data, onClose }) => {
  const [pending, setPending] = useState(false);

  const onError = () => setPending(false);
  const onSuccess = () => {
    setPending(false);
    onClose();
  };
  const [isLoading, deleteBannedWord] = useDeleteBannedWord({
    onSuccess,
    onError,
  });

  const handleDelete = () => {
    setPending(true);
    deleteBannedWord(data?.uuid);
  };

  return (
    <ModalCard size="sm" title="CONFIRM DELETION" onClose={onClose}>
      <div className="p-4 pt-2">
        <h5 className="pb-10 font-light">
          Are you sure you want to delete{' '}
          <span className="text-brand-600">{data?.ban_word || '--'}</span>?
        </h5>

        <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
          <AsyncButton
            color="outline"
            className="font-[400] !text-neutral-500"
            onClick={onClose}
          >
            Cancel
          </AsyncButton>
          <AsyncButton
            onClick={handleDelete}
            className="font-[400]"
            color="outline"
            isLoading={pending || isLoading}
            disabled={pending || isLoading}
          >
            confirm
          </AsyncButton>
        </div>
      </div>
    </ModalCard>
  );
};

Delete.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Delete;
